/*
 * 项目基础信息组件
 * zxw
 * 创建时间：
 * 修改时间：2026-07-08
*/

import React, { useState, useEffect, useCallback, useMemo } from 'react';
import $ from 'jquery';
import CNF from '../../incs/Config';
import {
    theme,
    message,
    Table,
    Input,
    Select,
    Button,
    Space,
} from 'antd';
import { PlusOutlined, ExportOutlined } from '@ant-design/icons';
import {
    UjoinParams,
    AddRequestHeaders,
    DateFormat,
    ShowIPModal,
    GetDropdownActionName,
} from '../../incs/FunHelper.js';
import ExportJsonExcel from 'js-export-excel';

import Entity from './BaseEntity';
import BaseInfo from './BaseInfo';
import WOMRSearch from '../wos/WOMRSearh';

const MODULENAME = CNF.navItems[0].submenu[0].name.replace('管理', '');
const MODULENAME_PTN = CNF.navItems[0].submenu[0].ptn;
const MODULENAME_URL = CNF.navItems[0].submenu[0].url;

const Lists = (props) => {
    const { btnLists, preGroup, dataLists, currentIndex, pageCount, changeIndex, setOpen, record, setRecord, refresh } = props;

    const [openBaseInfo, setOpenBaseInfo] = useState(false);
    const [openMonthlyReport, setOpenMonthlyReport] = useState(false);


    const update = useCallback((open, record = null) => {
        setRecord(record);
        setOpen(open);
    }, [setOpen, setRecord]);

    const setBaseInfoModel = useCallback((open, record = null) => {
        setRecord(record);
        setOpenBaseInfo(open);
    }, [setOpenBaseInfo, setRecord]);


    const setWoMonthlyReportModel = useCallback((open, record = null) => {
        setRecord(record);
        setOpenMonthlyReport(open);
    }, [setOpenMonthlyReport, setRecord]);

    /**
     * 操作选项
     * @param {*} action 
     * @param {*} record 
     */
    const operation = useCallback((action, record) => {
        const uri = MODULENAME_URL.slice(1) + '/' + record.key;
        switch (action) {
            case '月报':
                setWoMonthlyReportModel(true, record);
                break;
            case CNF.actionName.UPDATE:
                update(true, record);
                break;
            case CNF.actionName.DISABLE:
            case CNF.actionName.ACTIVE:
            case CNF.actionName.DELETE:
                ShowIPModal(record.key, record.rolename, action, MODULENAME, refresh, uri);
                break;
            default:
                break;
        }
    }, [refresh, setWoMonthlyReportModel, update]);

    const hasOpPerm = (
        btnLists.indexOf(MODULENAME_PTN + '_update') > 0 ||
        btnLists.indexOf(MODULENAME_PTN + '_wo_mr') > 0 ||
        btnLists.indexOf(MODULENAME_PTN + '_disable') > 0 ||
        btnLists.indexOf(MODULENAME_PTN + '_active') > 0 ||
        btnLists.indexOf(MODULENAME_PTN + '_delete') >= 0
    );

    const columns = useMemo(() => [
        { title: '', dataIndex: '', key: 'key', fixed: 'left', width: CNF.searchMarginLeft * 4, },
        {
            title: '项目名称', key: 'name', fixed: 'left',
            render: (record) => <Button
                color='primary'
                variant='link'
                style={{ padding: 0, border: 0, height: 22 }}
                onClick={() => { setBaseInfoModel(true, record); }}>{record.name}</Button>
        },
        { title: '项目编号', dataIndex: 'number', key: 'number', fixed: 'left', },
        { title: '项目类型', dataIndex: 'type', key: 'type', },
        { title: '项目阶段', dataIndex: 'phase', key: 'phase', },
        {
            title: '项目等级', key: 'phase',
            render: (record) => CNF.projectRanks.find(item => item.value === record.rank).key
        },
        { title: '项目区域', dataIndex: 'area', key: 'area', },
        { title: '创建时间', dataIndex: 'create_time', key: 'create_time', width: CNF.tableCreateTimeColumnWidth, },
        { title: '创建者', dataIndex: 'create_displayname', key: 'create_displayname', width: CNF.tableCreateDisplayeColumnWidth, },
        { title: '状态', dataIndex: 'status', key: 'status', width: CNF.tableStatusColumnWidth, },
        {
            title: '', key: 'operation', fixed: 'right', width: CNF.tableOperationColumnWidth, hidden: !hasOpPerm,
            render: (record) => GetDropdownActionName(btnLists, MODULENAME_PTN, record, operation)
        }
    ], [btnLists, hasOpPerm, operation, setBaseInfoModel]);

    return (
        <>
            <Table
                columns={columns}
                size='middle'
                dataSource={dataLists}
                pagination={{
                    showSizeChanger: false,
                    showQuickJumper: false,
                    showTotal: () => `共${pageCount > 10000 ? (pageCount / 10000).toFixed(CNF.DPL) + '万' : pageCount}条`,
                    pageSize: CNF.pageSize,
                    current: currentIndex,
                    total: pageCount,
                    onShowSizeChange: (current, pageSize) => props?.changePageSize(pageSize, current),
                    onChange: (current) => changeIndex(current),
                }}
            />
            {
                record && <BaseInfo
                    preGroup={preGroup}
                    btnLists={btnLists}
                    open={openBaseInfo}
                    setOpen={setBaseInfoModel}
                    record={record}
                />
            }
            {
                record && <WOMRSearch
                    preGroup={preGroup}
                    btnLists={btnLists}
                    open={openMonthlyReport}
                    setOpen={setWoMonthlyReportModel}
                    record={record}
                />
            }
        </>
    );
}

const ProjectBase = (props) => {
    const { btnLists, preGroup } = props;

    const { token: { pageSize, }, } = theme.useToken();

    const [loading, setLoading] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const [triggerRefresh, setTriggerRefresh] = useState(0);
    const [currentIndex, setCurrentIndex] = useState(1);
    const [pageCount, setPageCount] = useState(0);
    const [dataLists, setDataLists] = useState([]);
    const [record, setRecord] = useState(null);
    const [open, setOpen] = useState(false);
    const [status, setStatus] = useState(CNF.status[0].value);
    const refresh = useCallback(() => {
        setTriggerRefresh((prev) => prev + 1);
    }, []);

    const [name, setName] = useState('');
    const [number, setNumber] = useState('');
    const [type, setType] = useState('');
    const [phase, setPhase] = useState('');
    const [rank, setRank] = useState(0);
    const [area, setArea] = useState('');

    const changeIndex = useCallback((index) => {
        setCurrentIndex(index);
    }, []);

    const handleStatusChange = useCallback((value) => {
        setStatus(value || '');
        setCurrentIndex(1);
    }, []);

    const handleNameChange = useCallback((e) => {
        setName(e.target.value);
        setCurrentIndex(1);
    }, []);

    const handleNumberChange = useCallback((e) => {
        setNumber(e.target.value);
        setCurrentIndex(1);
    }, []);

    const handleTypeChange = useCallback((value) => {
        setType(value);
        setCurrentIndex(1);
    }, []);

    const handlePhaseChange = useCallback((value) => {
        setPhase(value);
        setCurrentIndex(1);
    }, []);

    const handleRankChange = useCallback((value) => {
        setRank(value);
        setCurrentIndex(1);
    }, []);

    const handleAreaChange = useCallback((e) => {
        setArea(e.target.value);
        setCurrentIndex(1);
    }, []);

    const setOpenModal = useCallback((open, record = null) => {
        setOpen(open);
        setRecord(record);
    }, []);

    const create = useCallback(() => {
        setOpenModal(true, null);
    }, [setOpenModal]);

    useEffect(() => {
        setLoading(true);

        let params = {
            page_size: pageSize,
            current_index: currentIndex,
            status,
            name,
            number,
            phase,
            type,
            rank,
            area,
        };

        // 注意：如果 0 也是有效值，需要额外处理，但此处页码和数量通常不为0或空
        params = Object.fromEntries(
            Object.entries(params).filter(([_, value]) => value !== '' && value !== null && value !== undefined)
        );

        $.ajax({
            url: `${CNF.api}${MODULENAME_URL.slice(1)}${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET',
        }).done((data) => {
            if (data.res === 0) {
                setDataLists(data.dat || []);
                setPageCount(data.cnt || 0);
            } else {
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail((err) => {
            messageApi.error(err.responseJSON?.detail || '请求失败', CNF.messageDuration);
        }).always(() => setLoading(false))
    }, [messageApi, pageSize, currentIndex, triggerRefresh, status, name, number,
        phase,
        type,
        rank,
        area]);

    /***
    * 导出为 Excel
    */
    const exportExecl = (data) => {
        var date = new Date();
        let option = {};  //    option代表的就是excel文件
        option.fileName = '项目基础信息明细-' + DateFormat('YYYY-mm-dd', date);  //   excel文件名称
        option.datas = [
            {
                sheetData: data,  //   excel文件中的数据源
                sheetName: '项目信息明细',  //  excel文件中sheet页名称
                sheetHeader: [
                    '项目编号',
                    '项目名称',
                    '项目类型',
                    '项目阶段',
                    '项目等级',
                    '项目区域',
                    '维护内容',
                    '备注',
                    '状态'
                ],  //  excel文件中每列的表头名称
            }
        ]
        let toExcel = new ExportJsonExcel(option);  //生成excel文件
        toExcel.saveExcel();  //下载excel文件
    }

    /***
     * 获取导出数据
     */
    const exportGetData = () => {
        let params = {
            page_size: pageSize,
            current_index: currentIndex,
            status,
            name,
            number,
            phase,
            type,
            rank,
            area,
        };

        // 注意：如果 0 也是有效值，需要额外处理，但此处页码和数量通常不为0或空
        params = Object.fromEntries(
            Object.entries(params).filter(([_, value]) => value !== '' && value !== null && value !== undefined)
        );

        $.ajax({
            url: `${CNF.api}project/bases${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET',
        }).done((data) => {
            if (data.res === 0) {
                if (data.dat.length > 0) {
                    //  删除非必须字段
                    var d = [];
                    for (let i = 0; i < data.dat.length; i++) {
                        var item = data.dat[i]
                        delete item['key'];
                        delete item['area_ulid'];
                        delete item['create_username']
                        delete item['create_displayname']
                        delete item['create_time']
                        delete item['update_time']
                        item['rank'] = CNF.projectRanks.find(item => item.value === data.dat[i].rank).key;
                        d.push(item);
                    }
                    exportExecl(d);
                } else {
                    exportExecl([]);
                }
            } else {
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail((err) => {
            messageApi.error(err.responseJSON?.detail || '请求失败', CNF.messageDuration);
        })
    }

    // 按钮权限判断
    const hasCreate = btnLists.includes(MODULENAME_PTN + '_create');
    const hasExport = btnLists.includes(MODULENAME_PTN + '_export');

    return (
        <>
            {contextHolder}
            <Space style={{ padding: CNF.searchMarginLeft * 4 }}>
                <Input
                    placeholder='项目名称'
                    value={name}
                    onChange={handleNameChange}
                />
                <Input
                    placeholder='项目编码'
                    value={number}
                    onChange={handleNumberChange}
                />
                <Select
                    allowClear
                    placeholder='项目类型'
                    onChange={handleTypeChange}
                    options={CNF.projectTypes.map((item, index) => ({
                        key: index,
                        value: item.value,
                        label: item.key
                    }))}
                />
                <Select
                    allowClear
                    placeholder='项目阶段'
                    onChange={handlePhaseChange}
                    options={CNF.projectPhases.map((item, index) => ({
                        key: index,
                        value: item.value,
                        label: item.key
                    }))}
                />
                <Input
                    placeholder='项目区域'
                    value={area}
                    onChange={handleAreaChange}
                />
                <Select
                    allowClear
                    placeholder='项目等级'
                    onChange={handleRankChange}
                    options={CNF.projectRanks.map((item, index) => ({
                        key: index,
                        value: item.value,
                        label: item.key
                    }))}
                />
                <Select
                    allowClear
                    placeholder='状态'
                    popupMatchSelectWidth={false}
                    style={{ width: '100%' }}
                    onChange={handleStatusChange}
                    options={CNF.status.map((item, index) => ({
                        key: index,
                        value: item.value,
                        label: item.label
                    }))}
                />
                {hasCreate && (
                    <Button
                        title={CNF.actionName.CREATE + MODULENAME}
                        color='primary'
                        variant='solid'
                        icon={<PlusOutlined />}
                        onClick={() => {
                            create();
                        }}>
                        {CNF.actionName.CREATE}
                    </Button>
                )}
                {hasExport && (
                    <Button
                        title={CNF.actionName.EXPORT + MODULENAME}
                        color='primary'
                        variant='solid'
                        icon={<ExportOutlined />}
                        onClick={() => {
                            exportGetData();
                        }}>
                        {CNF.actionName.EXPORT}
                    </Button>
                )}
            </Space>
            <Lists
                preGroup={preGroup}
                btnLists={btnLists}
                dataLists={dataLists}
                currentIndex={currentIndex}
                pageCount={pageCount}
                changeIndex={changeIndex}
                setOpen={setOpen}
                record={record}
                setRecord={setRecord}
                refresh={refresh}
                loading={loading}
            />
            <Entity
                preGroup={preGroup}
                btnLists={btnLists}
                open={open}
                record={record}
                setOpen={setOpenModal}
                refresh={refresh}
            />
        </>
    );
}

export default ProjectBase